import React, { useEffect, useState } from 'react';
import { AboutText, AboutTitle, CaptionText, Card, CardImage, CharacterTelescope, Constellation, ConstellationContainer, DataLink, DataText, PinkContainer, Section, Star2014, Star2015, Star2016, Star2017, Star2018, Star2019, Star2020, Star2021, Star2022, Star2023, Star2024, StatsText, YearText, BackgroundImage } from './styles';
import TelescopeCharacter from '../../assets/History/constellation/telescopecharacter.svg';
import ConstellationLit from '../../assets/History/constellation/dhconstlit.svg';
import ConstellationUnlit from '../../assets/History/constellation/dhconstunlit.svg';
import historyBackground from '../../assets/History/historyBackground.svg';

import svg20141 from '../../assets/History/card/20141.svg';
import svg20142 from '../../assets/History/card/20142.svg';
import svg20143 from '../../assets/History/card/20143.svg';
import svg20151 from '../../assets/History/card/20151.svg';
import svg20152 from '../../assets/History/card/20152.svg';
import svg20153 from '../../assets/History/card/20153.svg';
import svg20161 from '../../assets/History/card/20161.svg';
import svg20162 from '../../assets/History/card/20162.svg';
import svg20163 from '../../assets/History/card/20163.svg';
import svg20171 from '../../assets/History/card/20171.svg';
import svg20172 from '../../assets/History/card/20172.svg';
import svg20173 from '../../assets/History/card/20173.svg';
import svg20181 from '../../assets/History/card/20181.svg';
import svg20182 from '../../assets/History/card/20182.svg';
import svg20183 from '../../assets/History/card/20183.svg';
import svg20191 from '../../assets/History/card/20191.svg';
import svg20192 from '../../assets/History/card/20192.svg';
import svg20193 from '../../assets/History/card/20193.svg';
import svg20201 from '../../assets/History/card/20201.svg';
import svg20202 from '../../assets/History/card/20202.svg';
import svg20203 from '../../assets/History/card/20203.svg';
import svg20211 from '../../assets/History/card/20211.svg';
import svg20212 from '../../assets/History/card/20212.svg';
import svg20213 from '../../assets/History/card/20213.svg';
import svg20221 from '../../assets/History/card/20221.svg';
import svg20222 from '../../assets/History/card/20222.svg';
import svg20223 from '../../assets/History/card/20223.svg';
import svg20231 from '../../assets/History/card/20231.svg';
import svg20232 from '../../assets/History/card/20232.svg';
import svg20233 from '../../assets/History/card/20233.svg';
import svg20241 from '../../assets/History/card/20241.svg';
import svg20242 from '../../assets/History/card/20242.svg';
import svg20243 from '../../assets/History/card/20243.svg';

import blueStar from '../../assets/History/stars/blueStar.svg';
import blueStarHovered from '../../assets/History/stars/blueStarHovered.svg';
import blueStarClicked from '../../assets/History/stars/blueStarClicked.svg';
import orangeStar from '../../assets/History/stars/orangeStar.svg';
import orangeStarHovered from '../../assets/History/stars/orangeStarHovered.svg';
import orangeStarClicked from '../../assets/History/stars/orangeStarClicked.svg';
import yellowStar from '../../assets/History/stars/yellowStar.svg';
import yellowStarHovered from '../../assets/History/stars/yellowStarHovered.svg';
import yellowStarClicked from '../../assets/History/stars/yellowStarClicked.svg';
import pinkStar from '../../assets/History/stars/pinkStar.svg';
import pinkStarHovered from '../../assets/History/stars/pinkStarHovered.svg';
import pinkStarClicked from '../../assets/History/stars/pinkStarClicked.svg';
import { useSwipeable } from 'react-swipeable';

const data = require('./historyData.json');


const svgMap: { [key: string]: string } = {
    '20141': svg20141,
    '20142': svg20142,
    '20143': svg20143,
    '20151': svg20151,
    '20152': svg20152,
    '20153': svg20153,
    '20161': svg20161,
    '20162': svg20162,
    '20163': svg20163,
    '20171': svg20171,
    '20172': svg20172,
    '20173': svg20173,
    '20181': svg20181,
    '20182': svg20182,
    '20183': svg20183,
    '20191': svg20191,
    '20192': svg20192,
    '20193': svg20193,
    '20201': svg20201,
    '20202': svg20202,
    '20203': svg20203,
    '20211': svg20211,
    '20212': svg20212,
    '20213': svg20213,
    '20221': svg20221,
    '20222': svg20222,
    '20223': svg20223,
    '20231': svg20231,
    '20232': svg20232,
    '20233': svg20233,
    '20241': svg20241,
    '20242': svg20242,
    '20243': svg20243,
};

const History: React.FC = () => {
    const [selectedYear, setSelectedYear] = React.useState<number>(2014);
    const [selectedCardId, setSelectedCardId] = React.useState<number>(1);
    const [constellationComplete, setConstellationComplete] = React.useState<boolean>(false);
    const [aboutText,  setAboutText] = React.useState<string>("🪐  Click the constellation “DH 24” to explore hacker experiences from previous years!")

    const [hoveredStar, setHoveredStar] = useState<string | null>(null);
    const [clickedStars, setClickedStars] = useState<string[]>(["2014"]);
    
    const imageKey = `${selectedYear}${selectedCardId}`;
    const imageSrc = svgMap[imageKey];

    useEffect(() => {
        const interval = setInterval(() => {
          selectedCardId === 3 ? setSelectedCardId(1) : setSelectedCardId(selectedCardId + 1);
        }, 5000);
    
        return () => clearInterval(interval);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [selectedCardId]);

    useEffect(() => {
        if (!clickedStars.includes(selectedYear.toString())) {
            setClickedStars([...clickedStars, selectedYear.toString()]);
        }
        setSelectedCardId(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedYear]);

    useEffect(() => {
        if (clickedStars.length === 11) {
            setConstellationComplete(true);
        }
    }, [clickedStars])

    useEffect(() => {
        const updateAboutText = () => {
            if (window.innerWidth <= 600) {
                setAboutText("Swipe to explore hacker experiences from previous years at DubHacks!");
            } else {
                setAboutText("🪐  Click the constellation “DH 24” to explore hacker experiences from previous years");
            }
        };

        // Initial check
        updateAboutText();

        // Add event listener
        window.addEventListener('resize', updateAboutText);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', updateAboutText);
    }, []);

    const handleStarClick = (year: string) => {
        setSelectedCardId(1);
        setSelectedYear(parseInt(year));
        if (!clickedStars.includes(year)) {
            setClickedStars([...clickedStars, year]);
        }
    }

    const handleCardClick = () => {
        setSelectedCardId(selectedCardId === 3 ? 1 : selectedCardId + 1);
    };

    const handleNextYear = () => {
        if (selectedYear !== 2024) {
            setSelectedYear(selectedYear + 1);
        } else {
            setSelectedYear(2014);
        }
    }

    const handlePrevYear = () => {
        if (selectedYear !== 2014) {
            setSelectedYear(selectedYear - 1);
        } else {
            setSelectedYear(2024);
        }
    }

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => handleNextYear(),
        onSwipedRight: () => handlePrevYear(),
    });

    return (
        <Section id="about">
            <BackgroundImage src={historyBackground} alt="telescopeAurora" />
            <AboutTitle>HISTORY OF DUBHACKS</AboutTitle>
            <AboutText className="about-text">{aboutText}</AboutText>
            <CharacterTelescope src={TelescopeCharacter} alt="CharacterTelescope" />
            <ConstellationContainer>
                {constellationComplete ? <Constellation islit={true} src={ConstellationLit} alt="Constellation" /> : <Constellation islit={false} src={ConstellationUnlit} alt="Constellation" />}
                <Star2014
                    src={hoveredStar === '2014' ? yellowStarHovered : (clickedStars.includes("2014") ? yellowStarClicked : yellowStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2014")}
                    onMouseEnter={() => setHoveredStar('2014')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2014')}
                />
                <Star2015
                    src={hoveredStar === '2015' ? blueStarHovered : (clickedStars.includes("2015") ? blueStarClicked : blueStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2015")}
                    onMouseEnter={() => setHoveredStar('2015')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2015')}
                />
                <Star2016
                    src={hoveredStar === '2016' ? blueStarHovered : (clickedStars.includes("2016") ? blueStarClicked : blueStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2016")}
                    onMouseEnter={() => setHoveredStar('2016')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2016')}
                />
                <Star2017
                    src={hoveredStar === '2017' ? pinkStarHovered : (clickedStars.includes("2017") ? pinkStarClicked : pinkStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2017")}
                    onMouseEnter={() => setHoveredStar('2017')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2017')}
                />
                <Star2018
                    src={hoveredStar === '2018' ? orangeStarHovered : (clickedStars.includes("2018") ? orangeStarClicked : orangeStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2018")}
                    onMouseEnter={() => setHoveredStar('2018')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2018')}
                />
                <Star2019
                    src={hoveredStar === '2019' ? pinkStarHovered : (clickedStars.includes("2019") ? pinkStarClicked : pinkStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2019")}
                    onMouseEnter={() => setHoveredStar('2019')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2019')}
                />
                <Star2020
                    src={hoveredStar === '2020' ? blueStarHovered : (clickedStars.includes("2020") ? blueStarClicked : blueStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2020")}
                    onMouseEnter={() => setHoveredStar('2020')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2020')}
                />
                <Star2021
                    src={hoveredStar === '2021' ? yellowStarHovered : (clickedStars.includes("2021") ? yellowStarClicked : yellowStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2021")}
                    onMouseEnter={() => setHoveredStar('2021')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2021')}
                />
                <Star2022
                    src={hoveredStar === '2022' ? yellowStarHovered : (clickedStars.includes("2022") ? yellowStarClicked : yellowStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2022")}
                    onMouseEnter={() => setHoveredStar('2022')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2022')}
                />
                <Star2023
                    src={hoveredStar === '2023' ? orangeStarHovered : (clickedStars.includes("2023") ? orangeStarClicked : orangeStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2023")}
                    onMouseEnter={() => setHoveredStar('2023')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2023')}
                />
                <Star2024
                    src={hoveredStar === '2024' ? blueStarHovered : (clickedStars.includes("2024") ? blueStarClicked : blueStar)}
                    alt="Star"
                    isclicked={!!clickedStars.includes("2024")}
                    onMouseEnter={() => setHoveredStar('2024')}
                    onMouseLeave={() => setHoveredStar(null)}
                    onClick={() => handleStarClick('2024')}
                />
            </ConstellationContainer>
            <Card onClick={handleCardClick} {...swipeHandlers}>
                <PinkContainer>
                    <YearText>{selectedYear}</YearText>
                    <StatsText>
                        {data[selectedYear.toString()]["stats"]}   
                    </StatsText>
                </PinkContainer>
                
                <CardImage src={imageSrc} alt="Card Image" />
                <CaptionText>{data[selectedYear][selectedCardId]["caption"]}</CaptionText>
                {data[selectedYear][selectedCardId]["caption-url-text"] !== "" && (
                    <DataLink href={data[selectedYear][selectedCardId]["caption-url"]} target="_blank">
                        {data[selectedYear][selectedCardId]["caption-url-text"]}
                    </DataLink>
                )}

                {data[selectedYear][selectedCardId]["details"]["data"] !== "" && (
                    <DataText>{data[selectedYear][selectedCardId]["details"]["data"]}</DataText>
                )} 

                {data[selectedYear][selectedCardId]["details"]["url"] !== "" && (
                    <DataLink href={data[selectedYear][selectedCardId]["details"]["url"]} target="_blank">
                        {data[selectedYear][selectedCardId]["details"]["url-text"]}
                    </DataLink>
                )}
            </Card>
        </Section>
    );
}

export default History;